import { FC } from 'react';
import { PortableText, PortableTextComponents } from '@portabletext/react';
import { ArbitraryTypedObject, PortableTextBlock } from '@portabletext/types';

import { Body, H1, H2, H3, H4, Lead, List, ListItem, OrderedListItem, SubBody, Tag } from '@rikstv/shared-components';

// This file is a subset of defintions from Strim.WebApp/components/content-blocks/richText

const defaultRichTextComponents: PortableTextComponents = {
  block: {
    normal: ({ children }) => <Body>{children}</Body>,
    h1: ({ children }) => <H1>{children}</H1>,
    h2: ({ children }) => <H2>{children}</H2>,
    h3: ({ children }) => <H3>{children}</H3>,
    h4: ({ children }) => <H4>{children}</H4>,
    ingress: ({ children }) => <Lead>{children}</Lead>,
    'sub-body': ({ children }) => <SubBody>{children}</SubBody>,
    'sub-title-2': ({ children }) => <H2 lookLike="sub-title-2">{children}</H2>,
    tag: ({ children }) => <Tag>{children}</Tag>,
  },
  marks: {
    strong: ({ children }) => <b>{children}</b>,
  },
  list: {
    bullet: ({ children }) => (
      <span className="rds-body">
        <List>{children}</List>
      </span>
    ),
    number: ({ children }) => (
      <span className="rds-body">
        <List ordered={true}>{children}</List>
      </span>
    ),
  },
  listItem: {
    bullet: ({ children }) => <ListItem>{children}</ListItem>,
    number: ({ children }) => <OrderedListItem>{children}</OrderedListItem>,
  },
  types: {},
};

export type RichTextContent = PortableTextBlock | ArbitraryTypedObject[] | PortableTextBlock[];
interface Props {
  content: RichTextContent;
}

export const PortableTextToRDS: FC<Props> = ({ content }) => {
  const components = {
    block: { ...defaultRichTextComponents.block },
    marks: { ...defaultRichTextComponents.marks },
    list: { ...defaultRichTextComponents.list },
    listItem: { ...defaultRichTextComponents.listItem },
    types: { ...defaultRichTextComponents.types },
  };

  return <PortableText value={content} components={components} />;
};
